var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-51.943%",
    y1: "19.883%",
    x2: "100%",
    y2: "74.562%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223DFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC1AFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    opacity: 0.2,
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 11.24-.222-6.23c0-.558-.498-1.01-1.111-1.01H5.333c-.613 0-1.11.452-1.11 1.01L4 11.24h.77a.455.455 0 0 0-.009.087v.205c0 .258.216.468.483.468h.694c.266 0 .483-.21.483-.468v-.205c0-.03-.004-.06-.01-.088H9.59a.455.455 0 0 0-.01.088v.205c0 .258.217.468.483.468h.694c.267 0 .483-.21.483-.468v-.205c0-.03-.004-.06-.01-.088H12Zm-6.629-.977a.601.601 0 0 1-.61-.592c0-.327.273-.592.61-.592.337 0 .61.265.61.592a.601.601 0 0 1-.61.592ZM4.94 8.115l.083-2.558c0-.564.211-.787.747-.787h4.46c.535 0 .746.223.746.787l.086 2.558H4.939Zm5.69 2.148a.601.601 0 0 1-.61-.592c0-.327.273-.592.61-.592.337 0 .61.265.61.592a.601.601 0 0 1-.61.592Z",
    fill: "#B41CFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraffic);
export default __webpack_public_path__ + "static/media/traffic.d17a1d0a1745716490168f7950d416e2.svg";
export { ForwardRef as ReactComponent };